import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPassportPublicPageView } from '../utils/passportPublicAnalytics';

/**
 * GA4 SPA navigations on public Passport pages (/, /technology, /login, /register).
 * Initial page_view is sent by the static gtag snippet in index.html (same pattern as tranzit.io).
 */
export default function PassportPublicAnalytics() {
  const { pathname } = useLocation();
  const skipInitial = useRef(true);

  useEffect(() => {
    if (skipInitial.current) {
      skipInitial.current = false;
      return;
    }
    trackPassportPublicPageView(pathname);
  }, [pathname]);

  return null;
}
